import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  ...addressFormFields,
  {
    name: 'owner',
    label: 'Select Borrower',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'incomeType',
    label: 'Income Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'employerName',
    label: 'Employer Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'positionOrTitle',
    label: 'Job Title',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isCurrentlyEmployedHere',
    label: 'Are you currently employed here?',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'startDate',
    label: 'Start Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'endDate',
    label: 'End Date',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'yearsInProfession',
    label: 'Years in profession',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'monthsInProfession',
    label: 'Months in profession',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'employmentOwnershipType',
    label: 'I have an ownership interest of more than 25% in this employer',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'companyEin',
    label: 'Company EIN',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'taxFilingType',
    label: 'Tax Filing Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'titlePerTaxReturn',
    label: 'Title Per Tax Return',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'salaryType',
    label: 'Salary Type',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'salaryAmount',
    label: 'Amount / Monthly Compensation',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'seasonal',
    label: 'Seasonal',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isCorporateRelocation',
    label: 'Corporate Relocation',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isEmployeeLoan',
    label: 'Employee Loan',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'foreign',
    label: 'Foreign',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'workPhoneNumber',
    label: 'Phone Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isPreviousWorkAddressExist',
    label: 'I have previous business address',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isEmployedByPartyToTransaction',
    label:
      'I am employed by a family member, property seller, real estate agent, or other party to the transaction',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const employmentIncomeForm = {
  name: FormNames.EMPLOYMENT_INCOME,
  label: 'Employment & Income',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
